import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\apollo\\apollo-provider.js");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\node_modules\\@apollo\\client-integration-nextjs\\node_modules\\@apollo\\client-react-streaming\\dist\\index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\node_modules\\next-intl\\dist\\esm\\navigation\\shared\\BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\node_modules\\next-intl\\dist\\esm\\navigation\\shared\\LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\node_modules\\next-intl\\dist\\esm\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "D:\\tfs\\AZ01\\_work\\27\\s\\node_modules\\next\\dist\\shared\\lib\\lazy-dynamic\\dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "D:\\tfs\\AZ01\\_work\\27\\s\\node_modules\\next\\dist\\shared\\lib\\lazy-dynamic\\preload-css.js");
;
import(/* webpackMode: "eager" */ "D:\\tfs\\AZ01\\_work\\27\\s\\node_modules\\next\\font\\local\\target.css?{\"path\":\"app\\\\[locale]\\\\layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../public/fonts/rag/BrownLLSubHeb-Bold.woff2\",\"weight\":\"700\"},{\"path\":\"../../public/fonts/rag/BrownLLSubHeb-Regular.woff2\",\"weight\":\"400\"}],\"display\":\"swap\",\"variable\":\"--brown\"}],\"variableName\":\"rag\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\theme\\ThemeProviders.tsx");
;
import(/* webpackMode: "eager" */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\common\\bit\\MediaQueries.tsx");
;
import(/* webpackMode: "eager" */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\common\\bit\\RichTextWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\Container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\CustomDialog\\CustomDialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\Errors\\GeneralErrorMsg.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\layout\\Layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\MainContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\Story\\StaticStory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\Story\\StorySlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledDiv","StyledImageWrapper"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\StyledPageWrapper.tsx");
;
import(/* webpackMode: "eager" */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\theme\\theme.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useTransitionFadeInStyle"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\transitions\\useTransitionFadeInStyle.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useTransitionUpStyles"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\ui\\transitions\\useTransitionUpStyles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ReactQueryContext"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\utils\\ReactQueryContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useApi"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\utils\\useApi.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useOutsideClick"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\utils\\UseOutsideClick.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useUtmUrl"] */ "D:\\tfs\\AZ01\\_work\\27\\s\\utils\\useUtmUrl.ts");
